export default __webpack_public_path__ + "static/media/Rcoin.067fba8d.svg";